import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import images from "../../../assets/images/constantImages";
import { useNavigate } from "react-router-dom";
import icons from "../../../assets/images/constantIcons";

const ResetPassword = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object({
    new_password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("Password is required"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const apiUrl =
    role === "staff"
      ? "/staff_users/reset_password"
      : role === "vendor" ? "/vendors/reset_vendor_password"
        : role === "canteenUser" ? "/canteen_users/reset_password" : "/vendors/reset_vendor_password"

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await apiService.post(apiUrl, {
        id: values.id,
        new_password: values.new_password,
        password_confirmation: values.password_confirmation,
      });

      toast.success(response.message, { duration: 2000 });
      navigate("/");
    } catch (errors) {
      handleError(errors)
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="w-full bg-green flex justify-center items-center relative">
        <div className="w-full ">
          <img
            src={images.loginimage}
            alt="loginimage"
            className="w-full h-screen backdrop-blur-[8px] mix-blend-multiply"
          />
          <div className="absolute top-0 z-10 w-full">
            <img
              src={images.loginclipimage}
              alt=""
              className="w-full h-screen opacity-[8%]"
            />
          </div>
          <div className="absolute sm:right-10 lg:top-8 top-3 right-2">
            <img src={images.logo} alt="logo" className="w-[180px] h-[75px]" />
          </div>
        </div>
        <div className="bg-white rounded-lg w-[320px] xs:w-[430px] shadow-lg p-8 absolute z-30">
          <div className="w-full">
            <h1 className="text-G800 font-bold text-[25px] xs:text-[32px] mb-4">
              Reset Password
            </h1>
            <Formik
              initialValues={{
                id: localStorage.getItem("userId") || "", //Get ID from localStorage
                new_password: "",
                password_confirmation: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="space-y-4">
                  <div className=" text-G300 ">
                    <label
                      htmlFor="new_password"
                      className="block text-sm font-normal mb-2"
                    >
                      New Password
                    </label>
                    <div className="relative">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="new_password"
                        placeholder="Enter new password"
                        className="inputtext"
                      />
                      <span
                        className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-[#0D762A]"
                        onClick={() => setShowPassword(!showPassword)} // Toggle state
                      >
                        {showPassword ? (
                          <icons.FaEye className="w-5 h-5" />
                        ) : (
                          <icons.FaEyeSlash className="w-5 h-5" />
                        )}
                      </span>
                    </div>
                    <ErrorMessage
                      name="new_password"
                      component="div"
                      className="text-sm text-red "
                    />
                  </div>
                  <div className="text-G300">
                    <label
                      htmlFor="password_confirmation"
                      className="block text-sm font-normal mb-2"
                    >
                      Confirm Password
                    </label>
                    <div className="relative">
                      <Field
                        type={showConfirmPassword ? "text" : "password"}
                        name="password_confirmation"
                        placeholder="Confirm new password"
                        className="inputtext"
                      />
                      <span
                        className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-[#0D762A]"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        } // Toggle state
                      >
                        {showConfirmPassword ? (
                          <icons.FaEye className="w-5 h-5" />
                        ) : (
                          <icons.FaEyeSlash className="w-5 h-5" />
                        )}
                      </span>
                    </div>
                    <ErrorMessage
                      name="password_confirmation"
                      component="div"
                      className="text-sm text-red "
                    />
                  </div>
                  <div className="mt-6">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full py-2 px-4 bg-green text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                      {isSubmitting ? "Resetting..." : "Reset Password"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
